/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipManager {
  "use strict";

    import IDataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;
    import IMaintenanceFormCustomButton = Meevo.Components.Controls.IMaintenanceFormCustomButton;
    import ICancellationDates = Meevo.Components.Common.ICancellationDates;
    import BillingTypeEnum = Meevo.Model.BillingTypeEnum;
    import AutoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;
    import ClientMembershipBillFeeTypeEnum = Meevo.Model.ClientMembershipBillFeeTypeEnum;

    export interface IMembershipManagerSearchContext {
        clientId: string;
        id: string;
        firstName: string;
        lastName: string;
        membershipNumber: string;
        shortcut: string;
    }

    export class MembershipManagerContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public customButtonsSet: Array<IMaintenanceFormCustomButton>;
        private today: Date;
        private buttonsSet: Array<IMaintenanceFormCustomButton>;
        private sectionEndpoint: string;
        public stopFreezeBeforeBilled: boolean = true;
        public indicatorImage: string;
        public indicatorText: string;
        public isEnabledTransworld: boolean;
        public clientMembershipIndicatorEnum = Meevo.Model.ClientMembershipIndicatorEnum;
        public autoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;
        public billingTypeEnum = Meevo.Model.BillingTypeEnum;
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;
        public paymentSectionAllowSaveAfterBillInsert: boolean = false;
        dataService: Meevo.Components.Common.ClientMembershipDataService;

        public autoRenewSettings: any;
        public redirectedFromMain: boolean = false;
        public isReload: boolean = false;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.Common.ClientMembershipDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService,
                    protected $timeout: ng.ITimeoutService,
                    protected $locale: angular.ILocaleService,
                    protected clientMembership: IMembershipManagerSearchContext,
                    protected $filter: angular.IFilterService,
                    protected $scope: angular.IScope,
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.today = new Date();
            this.today.setHours(0,0,0,0);

            this.baseEndpoint = appSettings.API_ENDPOINTS.membershipManager;
            this.sectionTemplatePath = "app/plugins/membershipManager/sectionViews/";
            this.entityType = 'membership';
            this.buttonsSet = [{
                text: 'LABEL_CANCEL_MEMBERSHIP',
                classNames: 'meevo-button-lg meevo-bottom-button cancel-membership-btn',
                clickHandler: this.cancelMembership.bind(this),
                disableRules: () => false,
                visibilityRules: () => this.isInActiveState,
                securityRules: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_CANCELMEMBERSHIP,
                position: 'left'
            },
            {
                text: 'LABEL_MEMBERSHIPMANAGER_UNDO_CANCEL_MEMBERSHIP',
                classNames: 'meevo-button-lg meevo-bottom-button cancel-membership-btn',
                clickHandler: this.undoCancellation.bind(this),
                disableRules: () => false,
                visibilityRules: () => this.isCanUndoCancel,
                securityRules: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_UNDOMEMBERSHIPCANCELLATION,
                position: 'left'
            },
            {
                text: 'LABEL_VIEW_PRINT_EMAIL_MEMBER_DOCS',
                classNames: 'meevo-button-lg meevo-bottom-button',
                clickHandler: this.viewMemberDocs.bind(this),
                disableRules: () => false,
                visibilityRules: () => false,
                securityRules: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_VIEWPRINT,
                position: 'right'
            }];

            this.initializeSections();
            this.getTransworldStatus();
        }

        public get showCopy(): boolean {
            return false;
        }

        public get showDelete(): boolean {
            return false;
        }

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {IDataMaintenanceSection} item
         * @returns {}
         */
        selectSection(item: IDataMaintenanceSection<Model.DataMaintenance>): void {
            if ((this.selectedSection && this.navigationBlockedThisSection() && !(this.autoRenewSettings && this.autoRenewSettings.autoRenewEnabled === true)) || this.redirectedFromMain) {
                this.modalService.confirmHandler('MESSAGE_MEMBERSHIPMANAGER_CLOSE_UNSAVED', Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((response: boolean) => {
                        if (response === true) {
                            this.cancel();
                            this.selectMembershipSection(<IMembershipBaseSection>item);
                        }
                    });
            } else {
                this.selectMembershipSection(<IMembershipBaseSection>item);
            }
        }

        private selectMembershipSection(item: IMembershipBaseSection) {
            this.isReload = false;
            if (item.sectionId === 0) {
                this.customButtonsSet = this.buttonsSet;
            } else if (item.sectionId === 1) {
                this.customButtonsSet = this.buttonsSet.slice(2);
            } else {
                this.customButtonsSet = undefined;
            }
            this.buildSecurityKeys(item);
            super.selectSection(item);
        }

        private navigationBlockedThisSection(): boolean {
            return this.isCopying || this.isEditing || this.selectedSection.isEditing;
        }

        get navigationBlocked(): boolean {
            return false;
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsClientMembership = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                appSettings: this.appSettings,
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.appSettings.API_ENDPOINTS.membershipManager,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: <Meevo.Components.Common.ClientMembershipDataService>this.dataService,
                identityService: this.identityService,
                noun: Meevo.Model.NounEnum.ClientMembership,
                $q: this.$q,
                $timeout: this.$timeout,
                busyService: this.busyService,
                clientMembership: this.clientMembership,
                $rootScope: this.$rootScope,
                sectionSecurityKey:''
            };
         if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)){
                this.sections.push(new MainSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 0,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_MAIN',
                        template: 'main.html',
                        modalService: this.modalService,
                        $translate: this.$translate,
                        securityChecker: this.securityChecker,
                        noun: Meevo.Model.NounEnum.MembershipManagerMain,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        context: this,
                        $filter: this.$filter,
                    })));
            }

         if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_CCACH + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CCSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_CC',
                        template: 'cc.html',
                        modalService: this.modalService,
                        $translate: this.$translate,
                        securityChecker: this.securityChecker,
                        noun: Meevo.Model.NounEnum.MembershipManagerCC,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_CCACH + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        context: this,
                    })));
         }

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_PAYMENTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)){
                this.sections.push(new PaymentsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 2,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_PAYMENTS',
                        template: 'payments.html',
                        modalService: this.modalService,
                        $translate: this.$translate,
                        context: this,
                        noun: Meevo.Model.NounEnum.MembershipManagerPayments,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_PAYMENTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
           }

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_TRANSFER + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new TransferSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 3,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_TRANSFER',
                        template: 'transfer.html',
                        $translate: this.$translate,
                        modalService: this.modalService,
                        context: this,
                        securityChecker: this.securityChecker,
                        noun: Meevo.Model.NounEnum.MembershipManagerTransfers,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_TRANSFER + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })
                ))
          }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_BENEFITS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)){
                this.sections.push(new BenefitsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 4,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_BENEFITS',
                        template: 'benefits.html',
                        sectionEndpoint: 'Benefit',
                        noun: Meevo.Model.NounEnum.MembershipManagerBenefits,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_BENEFITS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
           }

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new HistorySection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 5,
                        displayNameContentKey: 'SECTION_MEMBERSHIPMANAGER_HISTORY',
                        template: 'history.html',
                        sectionEndpoint: 'History/List',
                        noun: Meevo.Model.NounEnum.MembershipManagerHistory,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
           }
        }

        initializeHeader(model: any): void {
            console.log('membership manager initalizeheader', model);
            this.headerContent = model.displayName;
            //this.headerSubContent = model.membership
        }

        updateMembershipIndicator(): angular.IPromise<any> {
            return this.dataService.getClientsMembershipIndicator(this.selectedSection.model['clientId'], false)
                .then((data: any) => {
                    this.clientMembership['clientMembershipIndicatorEnum'] = data[0].clientMembershipIndicatorEnum;
                    this.clientMembership['clientMembershipIndicatorStatus'] = data[0].clientMembershipIndicatorStatus;
                });
        }

        save(): angular.IPromise<any> {
            const promiseChain = [];

            if (this.selectedSection instanceof MainSection) {
                promiseChain.push(() => (this.selectedSection as MainSection).checkNextEFTWontBeFrozen());
            }

            return promiseChain.reduce((prevFunc, nextFunc) => {
                return prevFunc.then(nextFunc);
            }, this.$q.resolve())
                .then(() => this.actualSave())
                .then(() => {
                    this.$scope.$broadcast(Meevo.Components.Common.Messages.RESET_INDICATORS);
                });
        }

        /**
         * Override base save method
         * */
        actualSave(): angular.IPromise<any> {
            let updateModel = {},
                bodyRequest = {};

            this.sectionEndpoint = '';

            if (this.canSave) {
                this.selectedSection.preSave();

                if (this.selectedSection instanceof PaymentsSection
                    && this.selectedSection['insertPayment'].showInsertPaymentInputs) {
                    this.busyService.stop();
                    this.paymentSectionAllowSaveAfterBillInsert = true;
                    this.selectedSection['insertPayment'].showInsertPaymentInputs = false;
                    return this.selectedSection['insertPaymentBill']().then(() => {
                        // Update Membership after inserting bill
                        this.dataService.customMethodData(`${this.appSettings.API_ROOT}/membership/client/${this.selectedSection.model.id}`, 'GET', null)
                            .then((res) => {
                                this.selectedSection.model = res.data;
                                this.actualSave();
                            });
                    });
                }


                Object.keys(this.selectedSection.model).forEach((key) => {
                    if (this.selectedSection.originalEntity && this.selectedSection.originalEntity.hasOwnProperty(key)) {
                        if (!angular.equals(this.selectedSection.originalEntity[key], this.selectedSection.model[key])) {
                            updateModel[key] = this.selectedSection.model[key];

                            if (updateModel['paymentDayOfMonth'] || updateModel['membershipMemberSettings']) {

                                // for update entity version
                                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/membership/client/${this.selectedSection.model.id}`, 'GET', null)
                                    .then((res) => {
                                        this.selectedSection.model = res.data;

                                        if (updateModel['membershipMemberSettings']) {
                                            // for edit recurring fees
                                            if (!angular.isUndefined(updateModel['membershipMemberSettings'][0].recurringFee)) {
                                                updateModel['recurringFee'] = updateModel['membershipMemberSettings'][0].recurringFee;
                                                delete updateModel['membershipMemberSettings'][0].recurringFee;
                                            }

                                            // for edit renewal fees
                                            if (!angular.isUndefined(updateModel['membershipMemberSettings'][0].monthlyRenewalFee)) {
                                                updateModel['renewalFee'] = updateModel['membershipMemberSettings'][0].monthlyRenewalFee;
                                                delete updateModel['membershipMemberSettings'][0].monthlyRenewalFee;
                                            }
                                        }

                                        bodyRequest = {
                                            entityVersion: this.selectedSection.model.entityVersion,
                                            model: updateModel
                                        }

                                        return this.saveRequest(bodyRequest);
                                    });
                            }
                        }
                    } else {
                        if (!updateModel.hasOwnProperty(key)) {
                            updateModel[key] = this.selectedSection.model[key];

                            // Update cancellation
                            if (key == 'cancellationState') {
                                let model = this.selectedSection.model;

                                updateModel['cancelledDate'] = this.compileDateString(model['cancelledDate']);
                                updateModel['terminationDate'] = this.compileDateString(model['terminationDate']);
                                updateModel['membershipCancellationId'] = model['membershipCancellationId'];

                                if (model['isAccruedServiceDaysToExpireEnabled'] && !model['accruedServiceExpireDate']) {
                                    delete updateModel['accruedServiceExpireDate'];
                                    delete model['accruedServiceExpireDate'];
                                } else {
                                    updateModel['accruedServiceExpireDate'] = this.compileDateString(model['accruedServiceExpireDate']);
                                }
                            }
                        }
                    }
                });

                // only for Main tab
                if (this.selectedSection instanceof MainSection) {

                    if (updateModel['enrollmentDate']) {
                        let enrollmentDate = moment(this.selectedSection.model['enrollmentDate']).toDate();

                        updateModel['enrollmentDate'] = this.compileDateString(enrollmentDate);

                        let manualBillsList = this.selectedSection.model.originMembershipBills.filter(bill => bill.isManualBill);

                        if (manualBillsList.length > 0) {

                           return this.modalService.confirm('MESSAGE_MEMBERSHIPMANAGER_CHANGE_ENROLLMENT_DATE_REMOVE_MANUAL_BILLS')
                                .then((res: boolean) => {
                                    if (res) {
                                        bodyRequest = {
                                            entityVersion: this.selectedSection.model.entityVersion,
                                            model: updateModel
                                        }
                                        return this.saveRequest(bodyRequest);
                                    } else {
                                        this.cancel();
                                    }
                                });
                        }
                    }

                    if (updateModel['isFrozen'] !== undefined && (updateModel['autoRenewTypeEnum'] || updateModel['autoRenewEnabled'] !== undefined)) {
                        this.modalService.alert("MESSAGE_USER_FREEZE_AND_CHANGE_AUTO_RENEW");
                        return;
                    }

                    if (this.selectedSection.model.freezeStartDate >= this.selectedSection.model.renewalBeginsOn) {
                        if (!this.selectedSection.validateFreezeDates()) {
                            return;
                        }
                    }

                    // Update freeze
                    if (this.selectedSection.model.isFrozen === true) {
                        let model = this.selectedSection.model;

                        updateModel['freezeReason'] = model.freezeReason;
                        updateModel['freezeSettingEnum'] = model.freezeSettingEnum;
                        updateModel['freezeStartDate'] = this.compileDateString(model.freezeStartDate);
                        updateModel['isFrozen'] = true;
                        updateModel['scheduledReactivationDate'] = this.compileDateString(model.scheduledReactivationDate);
                        updateModel['scheduledReactivationManuallySet'] = model.scheduledReactivationManuallySet;

                        // Freeze bill for PIF Memberships
                        if (!this.selectedSection.membershipInFreezeStatus) {
                            if (this.selectedSection.membershipAccessDuringFreezeSetting
                                && model.billingTypeEnum === BillingTypeEnum.PaidInFull
                                && this.stopFreezeBeforeBilled
                            ) {
                                let today = moment().startOf('day').toDate(),
                                    modelAutoRenewTypeEnum = model.autoRenewTypeEnum,
                                    requestCreateBill = {
                                        clientMembershipId: model.id,
                                        paymentDate: today,
                                        reason: model.freezeReason,
                                        isFreezeBill: true,
                                        freezeSettingEnum: model.freezeSettingEnum
                                    },
                                    initialDateFromModel = moment(model.initialTerm).add(1, 'days').toDate(),
                                    isFreezeBillInInitialTerm = model.freezeStartDate < initialDateFromModel;

                                if (modelAutoRenewTypeEnum === AutoRenewTypeEnum.PaidInFull
                                    || ((modelAutoRenewTypeEnum === AutoRenewTypeEnum.Monthly || modelAutoRenewTypeEnum === AutoRenewTypeEnum.No) && isFreezeBillInInitialTerm)
                                ) {
                                    if (!this.selectedSection.membershipAccessDuringFreezeSetting.fee) {
                                        // If no fee need to save and create bill
                                        this.stopFreezeBeforeBilled = false;
                                        return this.actualSave().then((data: any) => {
                                            this.dataService.customMethodData('api/Membership/Client/Payment', 'POST', requestCreateBill)
                                                .then((res: any) => {
                                                    this.stopFreezeBeforeBilled = true;
                                                    this.updateMembershipIndicator();

                                                    this.selectSection(this.selectedSection);
                                                });
                                        });
                                    } else {
                                        this.busyService.stop();

                                        return this.modalService.confirmHandler('MESSAGE_FREEZE_FEE_BILL', Meevo.Components.Modal.ModalTranslationModes.Translate)
                                            .then((res: any) => {

                                                if (res === true) {
                                                    this.stopFreezeBeforeBilled = false;

                                                    this.dataService.customMethodData('api/Membership/Client/Payment', 'POST', requestCreateBill)
                                                        .then((res: any) => {
                                                            this.stopFreezeBeforeBilled = true;

                                                            let stateParams = {
                                                                action: Meevo.Components.Common.Messages.MANUAL_BILL_PAYMENT,
                                                                clientMembership: this.selectedSection.model,
                                                                clientMembershipBills: [{
                                                                    clientMembershipBillId: res.data.clientMembershipBillId,
                                                                    amount: res.data.amount,
                                                                    paymentDate: res.data.paymentDate,
                                                                    clientMembershipBillFeeType: res.data.clientMembershipBillFeeType,
                                                                    entityVersion: model.entityVersion,

                                                                    freezeSetting: res.data.freezeSettingEnum,
                                                                    freezeStartDate: this.compileDateString(model.freezeStartDate),
                                                                    freezeReactivationDate: this.compileDateString(model.scheduledReactivationDate),
                                                                    freezeReason: model.freezeReason
                                                                }],
                                                            };

                                                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                                                stateName: "register",
                                                                stateParams: stateParams
                                                            });

                                                            this.cancel();
                                                        });
                                                } else {
                                                    this.stopFreezeBeforeBilled = true;
                                                }
                                            });
                                    }
                                }
                            }
                        }
                    }

                    // AutoRenewType change on PIF
                    if ((updateModel['autoRenewEnabled'] !== undefined && (!updateModel['autoRenewEnabled'] && updateModel['autoRenewTypeEnum'])) && this.selectedSection.model.billingTypeEnum === BillingTypeEnum.PaidInFull) {
                        delete updateModel['autoRenewTypeEnum'];
                    }

                    // AutoRenewType change on Reccuring Membership
                    if (updateModel['autoRenewEnabled'] && this.selectedSection.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                        updateModel['autoRenewTypeEnum'] = AutoRenewTypeEnum.Monthly;
                    }
                }

                // only for CC/ACH tab
                if (this.selectedSection instanceof CCSection) {
                    let model = <Meevo.Model.ClientMembership>this.selectedSection.model;

                    this.sectionEndpoint = '/PaymentAccount';

                    if (model.paymentAccounts.length > 0) {
                        this.redirectedFromMain = false;
                    }

                    if (model.paymentAccounts[0].zipCode == '') {
                        this.modalService.alert('LABEL_EMPTY_ZIP_CODE');
                        return;
                    }

                    bodyRequest['paymentAccounts'] = model.paymentAccounts;
                    bodyRequest['entityVersion'] = this.selectedSection.model.entityVersion;
                } else {
                    bodyRequest = {
                        entityVersion: this.selectedSection.model.entityVersion,
                        model: updateModel
                    }
                }

                // only for Transfer tab
                if (this.selectedSection instanceof TransferSection) {
                    this.sectionEndpoint = '/Location';
                }

                if (this.paymentSectionAllowSaveAfterBillInsert || !(this.selectedSection instanceof PaymentsSection)) {
                    this.paymentSectionAllowSaveAfterBillInsert = false;
                    return this.saveRequest(bodyRequest);
                }
            }
        }

        handlePaymentAccountUpdateFailed(): ng.IPromise<any> {
            var primaryPaymentAccountInfo = this.selectedSection.model['paymentAccountsInfo']
                .find((paymentAccountInfo) => paymentAccountInfo.objectStateEnum === Model.ObjectStateEnum.Active && paymentAccountInfo.isPrimary === true);

            var secondaryPaymentAccountInfo = this.selectedSection.model['paymentAccountsInfo']
                .find((paymentAccountInfo) => paymentAccountInfo.objectStateEnum === Model.ObjectStateEnum.Active && paymentAccountInfo.isPrimary === false);

            var isPrimaryPaymentAccontUpdateFailed = this.selectedSection.model['paymentAccounts']
                .find((paymentAccount) => primaryPaymentAccountInfo !== undefined && paymentAccount.id === primaryPaymentAccountInfo.id && paymentAccount.isExternalUpdateFailed === true);

            var isSecondaryPaymentAccontUpdateFailed = this.selectedSection.model['paymentAccounts']
                .find((paymentAccount) => secondaryPaymentAccountInfo !== undefined && paymentAccount.id === secondaryPaymentAccountInfo.id && paymentAccount.isExternalUpdateFailed === true);

            if ((isPrimaryPaymentAccontUpdateFailed === undefined) && isSecondaryPaymentAccontUpdateFailed === undefined) {
                return this.$q.resolve();
            }
            
            let message = this.$translate.instant('MESSAGE_EXTERNAL_UPDATE_FAILED_MULTIPLE')
            message += '<ul style="margin:0">';

            if (isPrimaryPaymentAccontUpdateFailed) {
                message += '<li>' + this.$translate.instant('LABEL_PRIMARY_PAYMENT_ACCOUNT') + '</li>'
            }

            if (isSecondaryPaymentAccontUpdateFailed) {
                message += '<li>' + this.$translate.instant('LABEL_SECONDARY_PAYMENT_ACCOUNT') + '</li>'
            }

            message += '</ul>';

            return this.modalService.message(message);
        }

        saveRequest(body: any): ng.IPromise<any> {
            let addingMode = this.mode === Meevo.Model.MaintenanceFormState.Adding;


            //don't use finally on the promises below. this should be skipped if there is a warning
            //postAdd dismisses the data maint form.
            let finallyFcn = () => {
                this.loadingInProgress = false;
                this.updateCoBarData(this.selectedSection.model);
                this.clientMembership['clientMembershipStatusEnum'] = this.selectedSection.model['clientMembershipStatusEnum'];
                this.clientMembership['clientMembershipIndicatorStatus'] = this.selectedSection.model['clientMembershipIndicatorStatus'];
                this.clientMembership['clientMembershipIndicatorEnum'] = this.selectedSection.model['clientMembershipIndicatorEnum'];

                if (this.selectedSection instanceof CCSection && this.autoRenewSettings && this.autoRenewSettings.autoRenewEnabled === true) {
                    // GO to Main tab
                    this.selectSection(this.sections[0]);
                }

                this.handlePaymentAccountUpdateFailed();

                if (this.customDataContextConfig && this.customDataContextConfig.use) {
                    if (addingMode) {
                        // if entity didn't have id (wasn't created or copied yet)

                        this.selectedSection.customControlsModel.answers.map(answer => {
                            answer.entity_Id = this.selectedSection.model.id;

                            return answer;
                        });
                    }

                    this.selectedSection.saveCustomControls();
                }

            };


            this.loadingInProgress = true;

            return this.dataService.patch(this.baseEndpoint, body, new Guid(this.selectedSection.model.id), this.sectionEndpoint)
                .then((data: any) => {
                    if (data.isWarning) {
                        // this.handleWarnings(data.responseStatus.errors);
                    } else {
                        this.selectedSection.model = data;
                        this.selectedSection.takeBackup();
                        this.isReload = true;
                        this.selectedSection.sectionModelRetrieved();
                        this.setMode(Model.MaintenanceFormState.Readonly);
                        this.loggingService.trace(`Updates saved.`);
                        this.postUpdate(this.selectedSection.model);

                        finallyFcn();
                    }
                })
                .catch((reason: any) => {
                    this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                    //finallyFcn();
                    this.loadingInProgress = false;
                    throw reason;
                });
        }


        /**
         * Function which determins wether to show the 'Edit' option.
         * this was introduced to allow overriding the show edit logic.
         * @return {boolean}
         */
        showEditLogic(): boolean {
            if (this.selectedSection instanceof PaymentsSection) {
                return false;
            }

            return this.selectedSection.model['clientMembershipIndicatorStatus'] !== Model.ClientMembershipIndicatorStatusEnum.Suspended && super.showEditLogic();
        }

        /**
         * Extend the default behavior with additional rules
         * */
        public get canEdit(): boolean {
            let selectedSection = <IMembershipBaseSection>this.selectedSection;
            return this.itemId &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() &&
                !selectedSection.handlesOwnCrud &&
                this.isReadonly &&
                selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                selectedSection.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.CancelBeforeEnrollment &&
                selectedSection.validateCanEdit()
        }

        /**
         * Update section model on change of the membership select
         * */
        public updateMembershipInfo(sectionEndpoint): void {
            let selectedSection = <IMembershipBaseSection>this.selectedSection;
            let clientMembershipId = new Guid(selectedSection.model.id);

            this.busyService.start();
            this.dataService.getItem(this.baseEndpoint, clientMembershipId, sectionEndpoint)
                .then((data: any) => {
                    selectedSection.model = data;
                    selectedSection.model.id = clientMembershipId.toString();
                    selectedSection.takeBackup();
                    selectedSection.sectionModelRetrieved();
                    selectedSection.loadDependentData()
                        .finally(() => {
                            this.busyService.stop();
                        });
                    selectedSection.setDisplayName();
                    selectedSection.setMembershipShortcut();
                    this.initializeHeader(data);
                });
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
        }


        /**
         * Run membership cancellation process
         * */
        public cancelMembership(): void {
            // DISALLOW cancellation while a freeze is in effect or scheduled.
            // Reads the server-computed flag rather than clientMembershipIndicatorStatus: that badge is
            // precedence-ordered (Expired/Error/Suspended/CCDueToExpire/InCancellation all outrank Frozen) and
            // never reports Frozen at all for a freeze that has not started, so it would miss most of this rule.
            // The flag comes from the same Extensions.HasActiveOrScheduledFreeze used by
            // ClientMembershipPatchValidator, so the pre-check and the authoritative rule cannot drift.
            if (this.selectedSection.model['isFreezeActiveOrScheduled'] === true) {
                this.modalService.alert('MESSAGE_UNABLE_CANCEL_FROZEN_MEMBERSHIP');
                return;
            }

            if (this.selectedSection.model['clientMembershipStatusEnum'] === Meevo.Model.ClientMembershipStatusEnum.InActive) {

                // confirm
                this.modalService.confirmHandler('MESSAGE_MEMBERSHIPMANAGER_CANCELLATION_FOR_NOT_ACTIVE_MEMBERSHIP', Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((res: boolean) => {
                        if (res === true) {
                            this.selectedSection.model['cancellationState'] = Meevo.Model.ClientMembershipCancellationStateEnum.ImmediateCancellation;
                            this.cancelMembershipPopup();
                        }
                    });
            } else {
                this.cancelMembershipPopup();
            }
        }

        // Open Cancelation popup
        public cancelMembershipPopup(): ng.IPromise<any> {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/membershipManager/sectionViews/cancellationModalTemplate.html",
                controller: "meevo.plugins.membershipManager.CancellationModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    membership: this.selectedSection.model,
                    cancellationDatesSettings: this.selectedSection['cancellationDatesSettings']
                }
            };

            return this.modalService.showCustom(modalOptions)
                .then((params: any) => {
                    this.editExternal();
                    this.selectedSection['cancellationDatesSettings'] = <ICancellationDates>params.cancellationDatesSettings;
                    this.selectedSection['showAccruedServicesExpiredDate'] = params.showAccruedServicesExpiredDate;

                    this.$timeout(() => {
                        _.extend(this.selectedSection.model, <ICancellationParams>params.cancellationParams);
                    });
                });
        }

        public viewMemberDocs(): void {

        }

        /**
         * Trigger when user click the Undo Cancellation button
         * */
        public undoCancellation(): void {
            this.modalService.confirmHandler('MESSAGE_MEMBERSHIPMANAGER_UNDO_CANCELLATION', Meevo.Components.Modal.ModalTranslationModes.Translate)
                .then((response: boolean) => {
                    if (response) {
                        let sectionModel = <Meevo.Model.ClientMembership>this.selectedSection.model;

                        if (!this.selectedSection.originalEntity) {
                            this.selectedSection.takeBackup();
                        }
                        sectionModel.cancellationState = Meevo.Model.ClientMembershipCancellationStateEnum.UndoCancellation;
                        this.editExternal();
                        this.save();
                    }
                })
        }

        get isCanUndoCancel(): boolean {
            if (this.selectedSection.model) {
                return this.selectedSection.model.homeLocationId === this.identityService.locationId &&
                       (this.clientMembership['clientMembershipIndicatorStatus'] === Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation || this.selectedSection.model['undoCancellationAllowed']);
            }
        }

        get isInActiveState(): boolean {
            return this.selectedSection &&
                this.selectedSection.model &&
                this.selectedSection.model.homeLocationId === this.identityService.locationId &&
                !this.selectedSection.model['undoCancellationAllowed'] &&
                this.selectedSection.model['clientMembershipStatusEnum'] !== Meevo.Model.ClientMembershipStatusEnum.Cancelled &&
                this.selectedSection.model['clientMembershipStatusEnum'] !== Meevo.Model.ClientMembershipStatusEnum.CancelBeforeEnrollment &&
                this.selectedSection.model['clientMembershipIndicatorStatus'] !== Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation &&
                this.selectedSection.model['clientMembershipIndicatorStatus'] !== Meevo.Model.ClientMembershipIndicatorStatusEnum.Expired
        }

        private buildSecurityKeys(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_CCACH);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_PAYMENTS);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_TRANSFER);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_BENEFITS);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_HISTORY);
                    break;
                case 0:
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_MAIN);
                    break;

            }
        }

        /**
         * Get transworld status
         * @returns {}
         */
        private getTransworldStatus(): void {
            this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/settings/transworldFields/`, 'GET', null)
                .then(response => {
                    this.isEnabledTransworld = response.data.enableTransworld;
                });
        }

        postCancel() {
            super.postCancel();

            if (_.isFunction(this.selectedSection.postCancel)) {
                this.selectedSection.postCancel();
            }

            if(this.selectedSection instanceof TransferSection) {
                this.selectedSection['client'] = undefined;
            }

            this.autoRenewSettings = null;
        }

        /**
         * Determines whether or not the Maintenance Form should show the top level 'Edit' option.
         * @return {boolean}
         */
        get showEdit(): boolean {
            if (this.selectedSection instanceof PaymentsSection) {
                return false;
            }

            if (this.selectedSection instanceof CCSection) {
                return super.showEditLogic();
            }

            if (this.selectedSection.model) {
                return this.selectedSection.model['clientMembershipIndicatorStatus'] !== Model.ClientMembershipIndicatorStatusEnum.Suspended && super.showEditLogic();
            } else {
                return super.showEditLogic();
            }
        }

        edit(): void {
            let sectionModel = <Meevo.Model.ClientMembership>this.selectedSection.model;

            if (this.selectedSection instanceof TransferSection) {
                if (sectionModel.clientMembershipIndicatorStatus === Model.ClientMembershipIndicatorStatusEnum.Frozen &&
                    (
                        sectionModel.freezeSettingEnum === Meevo.Model.FreezeSettingEnum.NoAccess ||
                        sectionModel.freezeSettingEnum === Meevo.Model.FreezeSettingEnum.MemberBenefitsOnly
                    )
                ) {
                    let freezeType;
                    switch (sectionModel.freezeSettingEnum) {
                        case Meevo.Model.FreezeSettingEnum.NoAccess:
                            freezeType = this.$translate.instant('LABEL_NO_ACCESS');
                            break;
                        case Meevo.Model.FreezeSettingEnum.MemberBenefitsOnly:
                            freezeType = this.$translate.instant('LABEL_MEMBER_BENEFITS_ONLY');
                            break;
                    }

                    this.modalService.warning(this.$translate.instant('MESSAGE_MEMBERSHIP_TRANSFER_FROZEN',
                        { freezeType: freezeType }));
                } else {
                    if (!this.isHomeLocation()) {
                        this.securityChecker.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_OFFSITE_TRANSFERSERVICEOVERRIDE).then((item: Model.SecurityItem) => {
                            switch (item.securityAccess) {
                                case Model.SecurityAccessEnum.Deny:
                                    if (item.canElevate) {
                                        let defer = this.$q.defer();
                                        defer.promise.then(() => {
                                            super.edit();
                                        });
                                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, item.key.replace(/:/gi, '_'), item.displayName, this.identityService.current().userName, item.securityKeyPath);
                                    } else {
                                        return;
                                    }
                                    break;
                                case Model.SecurityAccessEnum.Grant:
                                    super.edit();
                                    break;
                                case Model.SecurityAccessEnum.Hide:
                                    return;
                            }
                        });
                    } else {
                        super.edit();
                    }
                }
            } else {
                super.edit();
            }
        }

        compileDateString(date: Date): string {
            let month = (date.getMonth() + 1).toString(),
                day = (date.getDate()).toString();

            month = +month < 10 ? `0${month}` : month;
            day = +day < 10 ? `0${day}` : day;

            return `${date.getFullYear()}-${month}-${day}`;
        }
        
        /* Check homeLocation of Membership */
        public isHomeLocation(): boolean {
            return this.selectedSection.model.homeLocationId === this.identityService.current().locationId;
        }

        public isCOLocation(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        public get auditNoun(): Meevo.Model.NounEnum {
            if (this.selectedSection) {
                const noun = this.selectedSection["auditNoun"];
                if (_.isUndefined(noun) === false && noun !== null) {
                    return noun;
                }
            }
            return null;
        }
    }
}
